import { ROOT_ROUTES } from '@/config/router';

/** CRM home — works on localhost, staging and prod (relative path). */
export const getCrmHomePath = (firstOrgSlug?: string): string =>
  firstOrgSlug ? `/org/${firstOrgSlug}` : ROOT_ROUTES.HOME;
